import { render, staticRenderFns } from "./CarnavalView.vue?vue&type=template&id=7b18f723&"
import script from "./CarnavalView.vue?vue&type=script&lang=ts&"
export * from "./CarnavalView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports